import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../core/auth/auth.service';
import {AuthRedirectorService} from '../../core/auth/auth-redirector.service';
import {Router} from '@angular/router';
import {FormValidationHelper} from '../../core/util/form-validation.helper';
import {StateService} from '../../state/state.service';
import {isNullOrUndefined} from 'util';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'app-request-password',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.scss']
})
export class ResetComponent implements OnInit {
  formErrors = {};
  form: FormGroup;
  error$: Observable<string>;

  private subscriptions: Subscription[] = [];

  constructor(private fb: FormBuilder,
              private auth: AuthService,
              private router: Router,
              private state: StateService,
              private formValidation: FormValidationHelper,
              private redirector: AuthRedirectorService) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
    });
    this.subscriptions.push(this.form.valueChanges
      .debounceTime(500)
      .subscribe(() => this.onValueChanged(this.form)));
    this.onValueChanged(this.form);
    this.getFormErrors();
    this.subscriptions.push(this.state.state$.subscribe(state => {
      if (state.auth.isAuthenticated) {
        this.redirector.redirect();
      }
    }));
    this.error$ = this.auth.error$.map(error => {
      if (isNullOrUndefined(error) || isNullOrUndefined(error.original)) {
        return error;
      }

      return error.original.message;
    });
  }

  private onValueChanged(form: FormGroup) {
    this.getFormErrors();
    this.formValidation.validate(form, this.formErrors );
  }

  getFormErrors() {
    this.formErrors = {
      username: [],
    };
  }

  onSubmit() {
    if (!this.form.valid) {
      return;
    }
    const data = this.form.value;
    this.auth.sendPasswordResetEmail(data.username);
  }

  login() {
    this.router.navigate(['/', 'login']);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/reset/reset.component.ts